import { render, staticRenderFns } from "./CapitalGainReport.vue?vue&type=template&id=23d0398a&"
import script from "./CapitalGainReport.vue?vue&type=script&lang=js&"
export * from "./CapitalGainReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports